import Panel from "../Panel.js"
import ListItem from "../ListItem.js"

export default class Options extends Panel {

  constructor(props, context) {
    super(props, context)
    this.listOptions = [
      {label: "Font Family", key: "fontFamily", value: "Arial"},
      {label: "Font Color", key: "fontColor", value: "Red"},
      {label: "Font Size", key: "size", value: "100%"},
      {label: "Font Opacity", key: "fontOpacity", value: "0%"},
      {label: "Background Color", key: "backgroundColor", value: "Black"},
      {label: "Background Opacity", key: "backgroundOpacity", value: "0%"},
      {label: "Window Color", key: "windowColor", value: "Red"},
      {label: "Window Opacity", key: "windowOpacity", value: "0%"},
      {label: "Character Edge Style", key: "edgeType", value: "None"},
      {label: "Edge Color", key: "edgeColor", value: "Red"},
      {label: "Edge Opacity", key: "edgeOpacity", value: "Red"},
      {label: "Scroll", key: "scroll", value: "Pop-out"},
    ]
  }

  static get contextTypes() {
    return super.contextTypes
  }


  render() {
    const OptionsList = this.listOptions.map((object, index) => {
      return <ListItem key={object.key} onClick={(event)=>this.props.viewChange(event, object.key)} direction="right">
                <span className="amp-label">{object.label}</span>
                <button className="amp-icon amp-icon-right amp-right" tabIndex="-1"></button>
                <span className="amp-right">
                  {this.props.captionsettings[object.key+"Label"]}
                </span>
             </ListItem>
    })

    return <div className="amp-captioning-options">
            <ListItem className="amp-list-title" onClick={(event)=>this.props.viewChange(event, "home")} direction="left">
              <button className="amp-icon amp-icon-left" tabIndex="-1"></button>
              <span>Options</span>
            </ListItem>
            {OptionsList}
           </div>
  }
}
